<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'chi-square-table-6';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.chi-square-table-6 {
  $height: 48px;
  $padding: 4px;
  --header-cell-height: #{$height};
  --body-cell-height: #{$height};
  $border: 1pt solid #c0bec7;
  thead {
    tr {
      &:nth-child(1) {
        th {
          div {
            border-bottom: $border;
          }
        }
      }
      &:nth-child(2) {
        th {
          &[rowspan='1'] {
            div {
              border-bottom: $border;
            }
          }
          &:first-child {
            div {
              border-left: $border;
            }
          }
          &:last-child {
            div {
              border-right: $border;
            }
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        & > div {
          font-size: 14px;
          border-left: $border;
          border-bottom: $border;
        }
        &:last-child {
          & > div {
            border-right: $border;
          }
        }
      }
      &:first-child {
        border-top: $border;
      }
      .empty {
        & > div {
          border-bottom: none;
        }
      }
      &:has(td:nth-child(2).empty) {
        border-bottom: $border;
        td {
          & > div {
            border-bottom: none;
          }
          &:not(:first-child) {
            div {
              border-left: none;
            }
          }
        }
      }
    }
  }
}
</style>
